/*
 * @Autor: dingxiaolin
 * @Date: 2021-01-06 16:59:54
 * @LastEditors: yinwenxuan yinwenxuan@vip56.cn
 * @LastEditTime: 2024-11-29 17:27:49
 */
// import { Public } from '@/http';
import {permissonRoutes} from '../../router';
import minxi from '../../common/util/minxi';
const login = {
    namespaced: true,
    state: {
        jwtToken: '',
        dayChecked:null,
        actionPermissions: ['1111'],
        jurisdiction:[],
        resjurisdiction:[]
    },
    mutations: {
        logout(state, vm) {},
        /**权限变更 */
        jurisdictionChange({state},payload){
            console.log('888',state.dayChecked);
            
            state.jurisdiction = payload
            if(state.dayChecked==true){
                console.log('777');
                localStorage.setItem('jurisdiction',JSON.stringify(payload))
            }else{
                console.log(888);
                sessionStorage.setItem('jurisdiction',JSON.stringify(payload))
            }
            
        },
        /**清空权限 */
        clearjurisdiction(state,payload = []){
            state.jurisdiction = payload 
        },
        setChecked(state,payload = []){
            state.dayChecked = payload
            localStorage.setItem('dayChecked',state.dayChecked)
        },
        
    },
    actions: {
        async login({ state, dispatch, commit, getters, rootGetters }) {
            // await Public.login({});
        },
        /**生成路由 */
        async generateRoutes(state,payload = []){
            let list = minxi.judgeRoture(permissonRoutes,payload)
            state.jurisdiction = list
            return list
        },
        /**生成路由 */
        async returnRoutes(state,payload = []){
            let list = minxi.judgeRoture(permissonRoutes,payload)
            console.log('list',list);
            
            return list
        },
        /**权限数组 */
        getjurisdictionArray({state},payload = []){
            state.resjurisdiction = payload
            console.log('state.dayChecked2',state.dayChecked);
            if(state.dayChecked==true){
                console.log('111');
                localStorage.setItem('jurisdiction',JSON.stringify(payload))
            }else{
                console.log(222);
                sessionStorage.setItem('jurisdiction',JSON.stringify(payload))
            }   
        },
        /**保存7日 */
        setChecked({ commit, state }, payload){
            state.dayChecked = payload
            commit('setChecked', payload)
        },
    },
    getters: {
        /**获取权限 */
        getjurisdiction(state) {
            let dayChecked = localStorage.getItem('dayChecked')
            if(dayChecked=='true'){
                console.log(111);
                
                return state.jurisdiction.length == 0 ? JSON.parse(localStorage.getItem('jurisdiction')) : [];
            }else{
                console.log(222);
                
                return state.jurisdiction.length == 0 ? JSON.parse(sessionStorage.getItem('jurisdiction')) : [];
            }
            
        }
    }
};

export default login;



// WEBPACK FOOTER //
// ./src/vuex/modules/login.ts